import { render, staticRenderFns } from "./ClientWizardComponent.vue?vue&type=template&id=480f7746&"
import script from "./ClientWizardComponent.vue?vue&type=script&lang=js&"
export * from "./ClientWizardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports